<template>
  <v-expansion-panels v-model="panel" flat>
    <v-expansion-panel>
      <v-expansion-panel-header class="px-2 dark--text font-weight-medium collapse-bar text-sm">
        {{ moment(index, 'MM YYYY').format('MMM YYYY') }}
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-card-text class="py-0">
          <v-timeline align-top dense>
            <logs-component
              v-for="(task, i) in tasks"
              :key="i"
              :modal-form="modalForm"
              :contact-array="contactArray"
              :task="task"
              @fetchContacts="$emit('fetchContacts', $event)"
              @fetchRecords="$emit('fetchRecords')"
            />
          </v-timeline>
        </v-card-text>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import { ref } from '@vue/composition-api'
import { mdiChevronRight, mdiChevronDown, mdiDelete } from '@mdi/js'
import Toaster from '@core/utils/sweetToast'
import { storeActions } from '@/store/storeConstants'
import store from '@/store'
import { formatDate } from '@core/utils/filter'
import moment from 'moment'
import LogsComponent from './LogsComponent.vue'

export default {
  components: { LogsComponent },
  props: {
    tasks: {
      type: Array,
      default: () => [],
    },
    index: {
      type: String,
      required: true,
    },
    modalForm: {
      type: Object,
      default: undefined,
    },
    contactArray: {
      type: Array,
      default: () => [],
    },
  },

  setup(props, { emit }) {
    const isVisible = ref(false)
    const { DELETE_BY_ID } = storeActions
    const panel = ref(null)

    const subjectList = ref([
      { text: 'Call', value: 0 },
      { text: 'Email', value: 1 },
      { text: 'Send Letter', value: 2 },
      { text: 'Send Quote', value: 3 },
      { text: 'Other', value: 4 },
    ])

    const getSubject = id => {
      const sub = subjectList.value.find(opt => {
        return opt.value === id
      })

      if (sub) {
        return sub.text
      }

      return ''
    }
    const deleteTask = id => {
      Toaster.confirmation("You won't be able to revert this.").then(resp => {
        const config = {
          component: 'task-management/logs',
          objectId: id,
        }
        if (resp.isConfirmed) {
          store
            .dispatch(`common/${DELETE_BY_ID}`, config)
            .then(({ data }) => {
              if (data.success) {
                emit('fetchRecords')
                Toaster.success(data.message)
              } else {
                Toaster.error(data.message, 'warning')
              }
            })
            .catch(() => {
              Toaster.error('An error occur, please try again later', 'warning')
            })
        }
      })
    }

    return {
      isVisible,
      getSubject,
      deleteTask,
      formatDate,
      panel,
      moment,
      icons: {
        mdiChevronRight,
        mdiChevronDown,
        mdiDelete,
      },
    }
  },
}
</script>

<style scoped lang="scss">
.log-card {
  border: thin solid rgb(222, 222, 222);
  padding: 10px;
  border-radius: 5px;
}
.collapse-bar {
  background: #eee;
  min-height: 40px !important;
}
</style>
